import { resolveMediaUrl } from '@/helpers/utils';
import {
  useCdaasCenturionHomepageContent,
  useCdaasCulinaryCollectiveContent,
} from './cdaasFetchyeHooks';

export const useCulinaryCollectiveContent = () => {
  const { data } = useCdaasCulinaryCollectiveContent();
  return data?.body?.data ?? {};
};

export const useCenturionHomepageContent = () => {
  const { data } = useCdaasCenturionHomepageContent();
  if (!data?.body?.homepage) return {};

  const { homepage } = data.body;
  const hero = {
    ...homepage.hero,
    backgroundVideoUrl: resolveMediaUrl(data.body.heroBackgroundVideo),
  };

  return {
    ...homepage,
    hero,
  };
};
